var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JqxTreeMap',{attrs:{"width":"100%","height":400,"renderCallbacks":_vm.renderCallbacks,"source":_vm.chartData,"hoverEnabled":true},on:{"click":function($event){return _vm.click($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }